/* eslint-disable @typescript-eslint/no-deprecated */

import * as React from 'react'
import styled from 'styled-components'
import { IndustryIcon } from '../IndustryIcon/IndustryIcon'
import { IndustryCategory, industryCategoryToIndustryCategoryTitle } from '../../domain'
import { Small } from '../../styles'
import { IndustryWithCount } from '../../application'

const ColItem: React.FC<{ industryCategory: IndustryCategory; count: number }> = ({ industryCategory, count }) => {
  return (
    <Container>
      <Image>
        <IndustryIcon industryCategory={industryCategory} imageStyle={{ width: '5rem', height: '5rem' }} />
      </Image>
      <Count>{count}</Count>
      <Name>{industryCategoryToIndustryCategoryTitle(industryCategory)}</Name>
    </Container>
  )
}

export const OrganizationsIndustryCategoryKey: React.FC<{
  industriesWithCount: IndustryWithCount[]
}> = ({ industriesWithCount }) => {
  return (
    <ContainerRow>
      {industriesWithCount.map((industryWithCount) => (
        <ColItem
          key={industryWithCount.industryCategory}
          industryCategory={industryWithCount.industryCategory}
          count={industryWithCount.count}
        />
      ))}
    </ContainerRow>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  width: 11rem;
`
const Image = styled.div``
const Count = styled(Small)`
  font-weight: bold;
  text-align: center;
`
const Name = styled(Small)`
  text-align: center;
  line-height: 1.7rem;
  text-transform: lowercase;
  &:first-letter {
    text-transform: uppercase;
  }
`

const ContainerRow = styled.div`
  display: flex;
  flex-flow: wrap;
`
